// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2b_gy","col":"styles_col__1__Qv"};